import store from "../redux/store/index";
import {
  doObviousOnMessageActions,
  onMessageGetEventErrorAndData
} from "./socketHelper";
const environment = process.env.NODE_ENV;

class Socket {
  static ws = null;
  static listeners = [];
  static timeout = 250;
  static LEAVE_MESSAGES = [
    "You have been kicked",
    "Host has ended the session.",
    "Goodbye"
  ];

  static sendMessage = (data) => {
    if (this.isOpen()) {
      console.log(
        "%c#####SOCKET-REQUEST#####",
        "background: gray; padding: 2px;",
        data
      );
      return this.ws.send(JSON.stringify(data));
    }
  };

  static addListener = (event, callback = () => {}, onError = () => {}) => {
    const id = Date.now().toString() + Math.random().toFixed(3);
    this.listeners.push({
      event,
      callback,
      onError,
      id
    });
    return () => this.removeListener(id);
  };

  static onMessage = (message) => {
    const { event, error, data } = onMessageGetEventErrorAndData(message);
    console.log(
      "%c#####SOCKET-RESPONSE#####",
      "background: olive; padding: 2px;",
      {
        event,
        error,
        data
      }
    );
    if (!error) {
      doObviousOnMessageActions(event, data);
    }
    this.listeners.forEach((listener) => {
      if (listener.event === event) {
        if (error) {
          listener.onError(data);
        } else {
          listener.callback(data);
        }
      }
    });
  };

  static removeListener(id) {
    const listeners = this.listeners.filter((listener) => listener.id !== id);
    this.listeners = listeners;
  }

  static reconnectHost = (data) => {
    let dataObj = {
      action: "host-rejoin",
      roomId: data.id,
      userId: data.host.user_id
    };
    this.sendMessage(dataObj);
  };

  static checkconnection = () => {
    let dataObj = {
      action: "ping"
    };
    this.sendMessage(dataObj);
  };

  static isOpen = () => {
    return this.ws?.readyState === WebSocket.OPEN;
  };

  static check = () => {
    let storeState = store.getStore().getState();
    if (!this.ws || this.ws.readyState === WebSocket.CLOSED) {
      if (storeState.paramsReducer?.paramsObj?.game_api) {
        const url = `${storeState.paramsReducer.paramsObj.game_api}/${storeState.paramsReducer.paramsObj.game_api_stage}`;
        // reconnect host
        this.connect(url);
      }
    }
    //check if websocket instance is closed, if so call `connect` function.
  };

  static heartbeat = () => {
    if (!this.ws) return;
    this.checkconnection();
  };

  static connect = (url, callback) => {
    let storeState = store.getStore().getState();
     let socketUrl =
       environment === "development"
        ? "wss://3fi9h53479.execute-api.us-east-1.amazonaws.com/apptest/"
         : "wss://3unowgxe3i.execute-api.us-east-1.amazonaws.com/prod/";
   if (url) {
      socketUrl = url;
     } else if (storeState.paramsReducer?.paramsObj?.game_api) {
       socketUrl = `${storeState.paramsReducer.paramsObj.game_api}/${storeState.paramsReducer.paramsObj.game_api_stage}`;
     }
   

    console.log("socketUrlsocketUrl: ", socketUrl);
    let connectInterval;
    this.ws = new WebSocket(socketUrl);
    this.ws.onopen = () => {
      this.socketInterval = setInterval(() => {
        this.heartbeat();
      }, 15000);
      this.timeout = 250;
      clearTimeout(connectInterval);
      if (callback) {
        callback();
      }
    };

    this.ws.onmessage = (message) => this.onMessage(message);

    this.ws.onclose = (e) => {
      console.log(
        "%c#####SOCKET-DISCONNECTED#####",
        "background: red; padding: 2px;"
      );
      clearInterval(this.socketInterval);
    };

    this.ws.onerror = (err) => {
      clearInterval(this.socketInterval);
      console.error(
        "Socket encountered error: ",
        err.message,
        "Closing socket"
      );
      this.ws.close();
    };
  };
  static disconnect() {
    clearInterval(this.socketInterval);
    this.ws?.close();
  }
}

export default Socket;
